import { render, staticRenderFns } from "./ApplicationFormDeleteModal.vue?vue&type=template&id=19803118&"
import script from "./ApplicationFormDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFormDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports